var map = {
	"./_collections": "CqdB",
	"./_collections.js": "CqdB",
	"./_path": "jaHJ",
	"./_path.js": "jaHJ",
	"./_transforms": "GcFX",
	"./_transforms.js": "GcFX",
	"./addAttributesToSVGElement": "ByqY",
	"./addAttributesToSVGElement.js": "ByqY",
	"./addClassesToSVGElement": "jEBx",
	"./addClassesToSVGElement.js": "jEBx",
	"./cleanupAttrs": "RS50",
	"./cleanupAttrs.js": "RS50",
	"./cleanupEnableBackground": "s6py",
	"./cleanupEnableBackground.js": "s6py",
	"./cleanupIDs": "6daX",
	"./cleanupIDs.js": "6daX",
	"./cleanupListOfValues": "68W1",
	"./cleanupListOfValues.js": "68W1",
	"./cleanupNumericValues": "9Nhu",
	"./cleanupNumericValues.js": "9Nhu",
	"./collapseGroups": "Evpg",
	"./collapseGroups.js": "Evpg",
	"./convertColors": "vLcs",
	"./convertColors.js": "vLcs",
	"./convertPathData": "AGvq",
	"./convertPathData.js": "AGvq",
	"./convertShapeToPath": "szIp",
	"./convertShapeToPath.js": "szIp",
	"./convertStyleToAttrs": "JXs7",
	"./convertStyleToAttrs.js": "JXs7",
	"./convertTransform": "444n",
	"./convertTransform.js": "444n",
	"./inlineStyles": "1CWO",
	"./inlineStyles.js": "1CWO",
	"./mergePaths": "4ALn",
	"./mergePaths.js": "4ALn",
	"./minifyStyles": "CRwW",
	"./minifyStyles.js": "CRwW",
	"./moveElemsAttrsToGroup": "oXRS",
	"./moveElemsAttrsToGroup.js": "oXRS",
	"./moveGroupAttrsToElems": "N3oc",
	"./moveGroupAttrsToElems.js": "N3oc",
	"./prefixIds": "WOe4",
	"./prefixIds.js": "WOe4",
	"./removeAttributesBySelector": "LB6a",
	"./removeAttributesBySelector.js": "LB6a",
	"./removeAttrs": "gOEo",
	"./removeAttrs.js": "gOEo",
	"./removeComments": "BGG6",
	"./removeComments.js": "BGG6",
	"./removeDesc": "g4j2",
	"./removeDesc.js": "g4j2",
	"./removeDimensions": "LlD/",
	"./removeDimensions.js": "LlD/",
	"./removeDoctype": "m+BR",
	"./removeDoctype.js": "m+BR",
	"./removeEditorsNSData": "yHGp",
	"./removeEditorsNSData.js": "yHGp",
	"./removeElementsByAttr": "4SdD",
	"./removeElementsByAttr.js": "4SdD",
	"./removeEmptyAttrs": "IRS9",
	"./removeEmptyAttrs.js": "IRS9",
	"./removeEmptyContainers": "eJZP",
	"./removeEmptyContainers.js": "eJZP",
	"./removeEmptyText": "QnHJ",
	"./removeEmptyText.js": "QnHJ",
	"./removeHiddenElems": "0SAt",
	"./removeHiddenElems.js": "0SAt",
	"./removeMetadata": "ws3N",
	"./removeMetadata.js": "ws3N",
	"./removeNonInheritableGroupAttrs": "AjKv",
	"./removeNonInheritableGroupAttrs.js": "AjKv",
	"./removeOffCanvasPaths": "FqYv",
	"./removeOffCanvasPaths.js": "FqYv",
	"./removeRasterImages": "7K4e",
	"./removeRasterImages.js": "7K4e",
	"./removeScriptElement": "HJib",
	"./removeScriptElement.js": "HJib",
	"./removeStyleElement": "uPXw",
	"./removeStyleElement.js": "uPXw",
	"./removeTitle": "ICpx",
	"./removeTitle.js": "ICpx",
	"./removeUnknownsAndDefaults": "ybIX",
	"./removeUnknownsAndDefaults.js": "ybIX",
	"./removeUnusedNS": "Dbg/",
	"./removeUnusedNS.js": "Dbg/",
	"./removeUselessDefs": "7iGt",
	"./removeUselessDefs.js": "7iGt",
	"./removeUselessStrokeAndFill": "SoaU",
	"./removeUselessStrokeAndFill.js": "SoaU",
	"./removeViewBox": "Oy0j",
	"./removeViewBox.js": "Oy0j",
	"./removeXMLNS": "0lxO",
	"./removeXMLNS.js": "0lxO",
	"./removeXMLProcInst": "M/mr",
	"./removeXMLProcInst.js": "M/mr",
	"./reusePaths": "4yUy",
	"./reusePaths.js": "4yUy",
	"./sortAttrs": "Pic2",
	"./sortAttrs.js": "Pic2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "btJh";


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgo/plugins ^\.\/.*$
// module id = btJh
// module chunks = 1